import {
  parseQuery,
  DefaultQueryParams,
  environmentBuilder,
  GameLiveConnection,
} from '@pascal/pascal-core';
import { popupStore } from '@pascal/pascal-core/shared/core/store';
import { gameService } from './GameService';
import { turboGameService } from './TurboGameService';
import {
  SOCKET_DECISIONS_METHODS,
  SOCKET_METHODS,
  TURBO_OR_TERMINAL_GAME_ID,
} from '../enums/constants';
import { gameName, socketGamePath, socketTurboPath } from '../enums/gameConfigsAndUrls';
import { gameStore } from '../store/gameStore';
import { FREE_BET_AWARDED_METHOD_NAME, FREE_BET_ENDED_METHOD_NAME } from '../enums/freeChipTypes';

let connectionCount = 0;

export class GameConnection extends GameLiveConnection {
  constructor(url) {
    super(url);
  }

  async sendGameGetInitialState(isFirst = true) {
    const {
      [DefaultQueryParams.GameTypeId]: gameTypeId,
      [DefaultQueryParams.PartnerId]: partnerId,
      [DefaultQueryParams.GameId]: gameId,
    } = parseQuery(window.location.search);

    const isTurbo = +gameId === TURBO_OR_TERMINAL_GAME_ID;
    super.onGetInitialStateResult(this.handleInitialResult);
    await super.sendGetInitialState(isTurbo ? { partnerId, gameId } : { partnerId, gameTypeId });
    if (gameStore.isHandleInitialStateEnded) {
      if (isFirst) {
        if (isTurbo) {
          this.executeTurboGameConnections();
        } else {
          this.executeGameConnections();
        }
        this.executeGlobalConnections();
      }
    }
  }

  handleInitialResult(data) {
    const {
      [DefaultQueryParams.GameTypeId]: gameTypeId,
      [DefaultQueryParams.PartnerId]: partnerId,
      [DefaultQueryParams.GameId]: gameId,
    } = parseQuery(window.location.search);
    const isTurbo = +gameId === TURBO_OR_TERMINAL_GAME_ID;
    if (!data || (!data.roundInfo && !isTurbo)) {
      if (connectionCount > 2) {
        // popupStore.open({ name: PopUps.ConnectionError });
        popupStore.onConnectionError(true);
      } else {
        setTimeout(() => {
          connectionCount += 1;
          super
            .sendGetInitialState(isTurbo ? { partnerId, gameId } : { partnerId, gameTypeId })
            .then(() => {});
        }, 1500);
      }
    } else if (isTurbo) {
      turboGameService.onGetInitialStateResult.call(turboGameService, data);
    } else {
      gameService.onGetInitialStateResult.call(gameService, data);
    }
  }

  onFreeBetEnded(handler) {
    super.on(FREE_BET_ENDED_METHOD_NAME, handler);
  }

  onFreeBetAwarded(handler) {
    super.on(FREE_BET_AWARDED_METHOD_NAME, handler);
  }

  sendDecisionAction(target, params) {
    super.invoke(target, params).then(() => {});
  }

  sendInsurance(data) {
    super.invoke(SOCKET_METHODS.INSURANCE, data).then(() => {});
  }

  executeGameConnections() {
    super.onBalanceUpdate();
    super.onGetBalanceResult();
    super.onBetsClosed(gameService.handleBetsClosed.bind(gameService));
    super.onRoundFinished(gameService.handleRoundFin.bind(gameService));
    super.onReconnected(gameService.handleReconnected.bind(gameService));
    super.onDoBetResult(gameService.handleDoBetResult.bind(gameService));
    super.onRoundStarted(gameService.handleRoundStart.bind(gameService));
    super.onResultReport(gameService.handleResultReport.bind(gameService));
    super.onDoBetResultValidation(gameService.handleDoBetResultValidation.bind(gameService));
  }

  executeTurboGameConnections() {
    super.onGetBalanceResult();
    super.onDoBetResult(turboGameService.handleDoBetResult.bind(turboGameService));
    super.onResultReport(turboGameService.handleResultReport.bind(turboGameService));
    super.onRoundFinished(turboGameService.handleRoundFin.bind(turboGameService));
    super.on(
      SOCKET_METHODS.AUTO_STAND_RESULT,
      turboGameService.handleAutoStandResult.bind(turboGameService)
    );
    super.onDoBetResultValidation(
      turboGameService.handleDoBetResultValidation.bind(turboGameService)
    );
    SOCKET_DECISIONS_METHODS.forEach((method) => {
      super.on(method, (data) =>
        turboGameService.handleDecisionEvents.bind(turboGameService)(method, data)
      );
    });
    // super.on(
    //   SOCKET_METHODS.TURBO_BET_ACCEPTED,
    //   turboGameService.handleTurboBetAccepted.bind(turboGameService)
    // );
    super.on(
      SOCKET_METHODS.DECISION_TIME,
      turboGameService.handleDecisionTime.bind(turboGameService)
    );
    // this.onCardResult(turboGameService.handleCardsResult.bind(turboGameService));
  }

  executeGlobalConnections() {
    super.onGameOpen();
    super.onMaintenanceNotify();
    super.onFreeBetEnded();
    super.onFreeBetAwarded();
    super.onFreeBetCountUpdate();
    super.onClose(gameService.handleConnectionError.bind(gameService));
    super.onReconnected(gameService.handleReconnected.bind(gameService));
    super.onReconnecting(gameService.handleReconnecting.bind(gameService));
  }
}

const { socketUrl } = environmentBuilder(gameName);
const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
const isTurbo = +gameId === TURBO_OR_TERMINAL_GAME_ID;

const url = (path) => ({ url: `${socketUrl}${path}` });

export const gameLiveConnection = new GameConnection(
  url(isTurbo ? socketTurboPath : socketGamePath)
);
